import React, { Component } from 'react';
import Select from 'react-select';

const options = [
{
  label: "",
  options: [
    { value: "AL", label: "Alabama" },
    { value: "AK", label: "Alaska" },
    { value: "AZ", label: "Arizona" },
    { value: "AR", label: "Arkansas" },
    { value: "CA", label: "California" },
    { value: "CO", label: "Colorado" },
    { value: "CT", label: "Connecticut" },
    { value: "DE", label: "Delaware" },
    { value: "DC", label: "District Of Columbia" },
    { value: "FL", label: "Florida" },
    { value: "GA", label: "Georgia" },
    { value: "HI", label: "Hawaii" },
    { value: "ID", label: "Idaho" },
    { value: "IL", label: "Illinois" },
    { value: "IN", label: "Indiana" },
    { value: "IA", label: "Iowa" },
    { value: "KS", label: "Kansas" },
    { value: "KY", label: "Kentucky" },
    { value: "LA", label: "Louisiana" },
    { value: "ME", label: "Maine" },
    { value: "MD", label: "Maryland" },
    { value: "MA", label: "Massachusetts" },
    { value: "MI", label: "Michigan" },
    { value: "MN", label: "Minnesota" },
    { value: "MS", label: "Mississippi" },
    { value: "MO", label: "Missouri" },
    { value: "MT", label: "Montana" },
    { value: "NE", label: "Nebraska" },
    { value: "NV", label: "Nevada" },
    { value: "NH", label: "New Hampshire" },
    { value: "NJ", label: "New Jersey" },
    { value: "NM", label: "New Mexico" },
    { value: "NY", label: "New York" },
    { value: "NC", label: "North Carolina" },
    { value: "ND", label: "North Dakota" },
    { value: "OH", label: "Ohio" },
    { value: "OK", label: "Oklahoma" },
    { value: "OR", label: "Oregon" },
    { value: "PA", label: "Pennsylvania" },
    { value: "RI", label: "Rhode Island" },
    { value: "SC", label: "South Carolina" },
    { value: "SD", label: "South Dakota" },
    { value: "TN", label: "Tennessee" },
    { value: "TX", label: "Texas" },
    { value: "UT", label: "Utah" },
    { value: "VT", label: "Vermont" },
    { value: "VA", label: "Virginia" },
    { value: "WA", label: "Washington" },
    { value: "WV", label: "West Virginia" },
    { value: "WI", label: "Wisconsin" },
    { value: "WY", label: "Wyoming" },
    { value: "AA", label: "Armed Forces Americas" },
    { value: "AE", label: "Armed Forces Europe" },
    { value: "AP", label: "Armed Forces Pacific" }
  ]
},
{
  label: "",
  options: [
    { value: "AB", label: "Alberta" },
    { value: "BC", label: "British Columbia" },
    { value: "MB", label: "Manitoba" },
    { value: "NB", label: "New Brunswick" },
    { value: "NL", label: "Newfoundland and Labrador" },
    { value: "NT", label: "Northwest Territories" },
    { value: "NS", label: "Nova Scotia" },
    { value: "NU", label: "Nunavut" },
    { value: "ON", label: "Ontario" },
    { value: "PE", label: "Prince Edward Island" },
    { value: "QC", label: "Quebec" },
    { value: "SK", label: "Saskatchewan" },
    { value: "YT", label: "Yukon" }
  ]
}
];

export default class State extends Component {
  constructor(props){
    super(props)
    this.state = {
      selectedOption: null
    }
    this.setDefaultValue = this.setDefaultValue.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }
  handleChange(selectedOption){
    this.setState({ selectedOption }, function(){
      window.myForm.addHiddenFields({
        State: selectedOption.value
      })
      this.props.setValue(selectedOption.value)
    });
  }
  setDefaultValue(code){
    let selectedOption = options[0].options.filter(({value}) => value === code) 
    if (selectedOption.length < 1)
      selectedOption = options[1].options.filter(({value}) => value === code) 

    this.setState({selectedOption}, function(){
      this.props.setValue(selectedOption[0])
    })
  }
	render(){
	  const { selectedOption } = this.state;
		return (			
			<div className={"field-wrapper " + (this.props.showError ? ' invalid' : '')}>
				<label>{this.props.country === 'Canada' ? "Province" : "State"}</label>
				<Select
					className="dropdown"
					value= {selectedOption}
					placeholder=""
					onChange={e => this.handleChange(e)}
          options={this.props.country === 'Canada' ? options[1].options : options[0].options}
          menuPlacement="top"
				/>			
			<span className="error-msg">Please choose your state.</span>
		</div>
		)	
	}
}	
